<template>
    <div>
        <router-view></router-view>
        <!-- App Bottom Menu -->
        <div
            class="appBottomMenu shadow-header-footer"
            style="max-width: 480px; margin: auto"
            v-if="
                (isAuth && currentPage === 'home') ||
                currentPage === 'transaction.index' ||
                currentPage === 'kemitraan' ||
                currentPage === 'info.index' ||
                currentPage === 'account'
            "
        >
            <router-link
                :to="{ name: 'home' }"
                class="item"
                :class="[currentPage.includes('home') ? activeClass : '']"
            >
                <div class="col">
                    <ion-icon name="home"></ion-icon>
                    <strong>Beranda</strong>
                </div>
            </router-link>
            <router-link
                :to="{ name: 'transaction.index' }"
                class="item"
                :class="[
                    currentPage.includes('transaction') ? activeClass : '',
                ]"
            >
                <div class="col">
                    <ion-icon name="clipboard"></ion-icon>
                    <strong>Riwayat</strong>
                </div>
            </router-link>
            <router-link
                :to="{ name: 'kemitraan' }"
                class="item"
                :class="[currentPage.includes('kemitraan') ? activeClass : '']"
            >
                <div class="col">
                    <ion-icon name="storefront"></ion-icon>
                    <strong>Kemitraan</strong>
                </div>
            </router-link>
            <router-link
                :to="{ name: 'info.index' }"
                class="item"
                :class="[currentPage.includes('info') ? activeClass : '']"
            >
                <div class="col">
                    <ion-icon name="newspaper"></ion-icon>
                    <strong>Info</strong>
                </div>
            </router-link>
            <router-link
                :to="{ name: 'account' }"
                class="item"
                :class="[currentPage.includes('account') ? activeClass : '']"
            >
                <div class="col">
                    <ion-icon name="person-circle"></ion-icon>
                    <strong>Akun</strong>
                </div>
            </router-link>
        </div>
        <!-- dialog ALERT CREATE PIN -->
        <Dialog
            ref="dialog_alert_create_pin"
            :loading="false"
            :title="'Informasi Keamanan'"
            @confirm="directCreatePin()"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Buat PIN Kemanan untuk menjaga keamanan akun kamu. Buat
                Sekarang?</span
            >
        </Dialog>

        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_update_webapp"
            :loading="loading_dialog_update_version"
            :title="'Informasi Update'"
            @confirm="clearCacheApp()"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Versi Terbaru Aplikasi kini telah Tersedia. Perbarui
                sekarang!</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
    export default {
        name: 'App',
        data() {
            return {
                activeClass: 'active',
                alertCreatePin: false,
                loading_dialog_update_version: false,
            };
        },
        created() {
            if (this.isAuth) {
                this.getCustomer().then(() => {
                    this.getGroupProductSpecial();
                    this.getCategoryPrabayar();
                    this.getCategoryPascabayar();
                    this.loading.app = false;
                });
                this.getSetting().then(() => {
                    this.loading.app = false;
                });
            }

            const cachedData = localStorage.getItem('districtsData');
            if (!cachedData) {
                this.getDistrictsAll();
            } else {
                this.$store.commit('SET_DISTRICTS_ALL', JSON.parse(cachedData));
            }

            const unregisterRouterGuard = this.$router.beforeEach(
                (to, from, next) => {
                    const isShown = window.$('.modal').hasClass('show');
                    if (isShown) {
                        window.$('.modal').modal('hide');
                        next(false);
                    } else {
                        next();
                    }
                }
            );
            this.$once('hook:destroyed', () => {
                unregisterRouterGuard();
            });
        },
        computed: {
            ...mapState([
                'customer',
                'token',
                'loading',
                'device',
                'VUE_ENV',
                'version',
                'districtsAll',
            ]),
            ...mapMutations(['SET_DEVICE', 'SET_DISTRICTS_ALL']),
            ...mapGetters(['isAuth']),
            currentPage() {
                return this.$route.name;
            },
        },
        mounted() {
            if (
                navigator.userAgent.indexOf(
                    this.VUE_ENV.VUE_APP_PACKAGENAME_APK
                ) >= 0
            ) {
                this.$store.commit('SET_DEVICE', 'APK');
                this.checkVersion().then(response => {
                    if (this.version.webapp != response.webapp) {
                        this.dialogUpdateWebApp('show');
                    }
                });
            } else {
                this.$store.commit('SET_DEVICE', 'WEB');
            }
        },
        watch: {
            'customer.pin': function (newValue) {
                if (!newValue) {
                    setTimeout(() => {
                        if (
                            !this.customer.pin &&
                            this.isAuth &&
                            this.currentPage === 'home'
                        ) {
                            this.showAlertCreatePin();
                        }
                    }, 500);
                }
            },
        },
        methods: {
            ...mapActions([
                'getCustomer',
                'getSetting',
                'getCategoryPrabayar',
                'getCategoryPascabayar',
                'checkVersion',
                'getGroupProductSpecial',
                'getDistrictsAll',
            ]),
            showAlertCreatePin() {
                let element = this.$refs.dialog_alert_create_pin.$el;
                window.$(element).modal('show');
            },
            directCreatePin() {
                let element = this.$refs.dialog_alert_create_pin.$el;
                window.$(element).modal('hide');
                this.$router.push({
                    name: 'account.pin.form',
                });
            },
            dialogUpdateWebApp(value) {
                let element = this.$refs.dialog_alert_update_webapp.$el;
                window.$(element).modal(value);
            },
            clearCacheApp() {
                this.loading_dialog_update_version = true;
                setTimeout(() => {
                    if (typeof window.AndroidNative !== 'undefined') {
                        window.AndroidNative.clearWebViewCacheAndRestart();
                    }
                    this.loading_dialog_update_version = false;
                    this.dialogUpdateWebApp('hide');
                }, 3000);
            },
        },
    };
</script>
